<label class="image-button-wrapper">
  <div>
    <button
      type="button"
      class="drop-container"
      mat-raised-button
      color="primary"
      ngFileDrop
      (click)="fileInput.click()"
      (uploadOutput)="onUploadOutput($event)"
      [uploadInput]="uploadInput"
      [ngClass]="{ 'is-drop-over': dragOver, preview: preview }"
    >
      <input
        #fileInput
        type="file"
        ngFileSelect
        [accept]="acceptTypes"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput"
        [style.display]="'none'"
      />

      <div class="titles">
        <span class="upload-title" *ngIf="!dragOver">Select file</span>
        <span class="upload-title-drag" *ngIf="dragOver">{{ "upload.file-upload.upload-title-drag" | translate }}</span>
        <mat-error *ngIf="error">{{ error | translate }}</mat-error>
      </div>
    </button>
    <ng-content select="[data-required-indicator]"></ng-content>
  </div>
  <div class="tooltip-wrapper">
    <ng-content select="[data-requirements-tooltip]"></ng-content>
  </div>
</label>

<ng-container *ngIf="isFileListVisible">
<div class="file-info" *ngFor="let file of files">
  <div class="file-progress" *ngIf="file.progress.status === uploadStatus.Uploading">
    <div class="name_speed">
      <mat-icon class="file-icon">insert_drive_file</mat-icon>
      <p class="name">{{ file.name }}</p>
      <p class="speed">{{ file.progress.data.speedHuman }}</p>

      <p class="uploading-title">Uploading ...</p>
      <mat-icon class="cancel" (click)="cancelUpload(file.id)">clear</mat-icon>
    </div>

    <mat-progress-bar
      *ngIf="file.progress.data"
      class="example-margin"
      [color]="'primary'"
      [mode]="'determinate'"
      [value]="file.progress.data.percentage"
    >
    </mat-progress-bar>
  </div>

  <div class="file-result" *ngIf="file.progress.status === uploadStatus.Done">
    <mat-icon class="file-icon">insert_drive_file</mat-icon>
    <p class="name">{{ file.name }}</p>
    <div class="download_remove">
      <p>
        <a class="download" [href]="file.response">
          <img src="./assets/img/icons/download.svg" alt=""/>
        </a>
      </p>

      <p class="remove" (click)="removeFile()">
        <mat-icon>delete</mat-icon>
      </p>
    </div>
  </div>

  <div class="file-name">
    <mat-form-field>
      <input
        type="text"
        (change)="onTitleChangeUploadFile($event, file)"
        [value]="file.customTitle ? file.customTitle : file.name"
        matInput
        placeholder="Title"
      />
    </mat-form-field>
  </div>
</div>

<div class="existing-file-info" *ngIf="files.length === 0 && existingFileUrl">
  <div class="file-result">
    <mat-icon class="file-icon">insert_drive_file</mat-icon>
    <p class="name">{{ file.FileName }}</p>
    <div class="download_remove">
      <p>
        <a class="download" [href]="existingFileUrl">
          <img src="./assets/img/icons/download.svg" matTooltip="{{ 'system.download' | translate }}" alt=""/>
        </a>
      </p>

      <p class="remove" (click)="removeFile()">
        <mat-icon matTooltip="{{ 'system.Remove' | translate }} ">delete</mat-icon>
      </p>
    </div>
  </div>

  <div class="file-name">
    <mat-form-field>
      <input
        type="text"
        (change)="onExistFileTitleChange($event)"
        [value]="file.Title"
        matInput
        placeholder="Title"
      />
    </mat-form-field>
  </div>

</div>
</ng-container>
